/**
 * Module codes for permission checks
 * Used to avoid magic strings and ensure type safety
 */
export const MODULE_CODES = {
  INVOICE: "invoice",
  BILL: "bill",
  BANK_TRANSACTION: "bank_transaction",
  CREDIT_NOTE: "credit_note",
  DEBIT_NOTE: "debit_note",
  JOURNAL: "journal",
  AP_AR_JOURNAL: "ap_ar_journal",
  CUSTOMER: "customer",
  VENDOR: "vendor",
  BANK_ACCOUNT: "bank_account",
  GL: "gl",
} as const;

/**
 * Action codes for permission checks
 * Used to avoid magic strings and ensure type safety
 */
export const ACTION_CODES = {
  CREATE: "create",
  UPLOAD: "upload",
  UPDATE: "update",
  UPDATE_AFTER_PUSH: "update_after_push",
  DELETE: "delete",
  DELETE_AFTER_PUSH_TO_ZOHO: "delete_after_push_to_zoho",
  PUSH_TO_ZOHO: "push_to_zoho",
  PUSH_TO_ZOHO_WITHOUT_ATTACHMENT: "push_to_zoho_without_attachment",
  EDIT: "edit",
  CREATE_RECURRING: "create_recurring",
  DUPLICATE_JOURNAL: "duplicate_journal",
  CANCEL_RECURRING_BEFORE_END: "cancel_recurring_before_end",
  OVERRIDE_GL_PERMANENT: "override_gl_permanent",
  OVERRIDE_GL_ONCE: "override_gl_once",
  REJECT: "reject",
  DUPLICATE: "duplicate",
  WRITE_OFF: "write_off",
  CANCEL_WRITE_OFF: "cancel_write_off",
  AP_AR_CREATE: "ap_ar_create",
  AP_AR_DELETE: "ap_ar_delete",
  MATCH: "match",
  UNMATCH: "unmatch",
  SPLIT_TRANSACTION: "split_transaction",
  SPLIT_TRANSACTION_AMOUNT: "split_transaction_amount",
  ADVANCE: "advance",
  EXPENSE_HIGH_VALUE: "expense_high_value",
  BULK_UPLOAD: "bulk_upload",
} as const;

export type ModuleCode = (typeof MODULE_CODES)[keyof typeof MODULE_CODES];
export type ActionCode = (typeof ACTION_CODES)[keyof typeof ACTION_CODES];
